export const AlertBox = {
  mounted() {
    // Check if content overflows the container
    this.checkOverflow();

    this.el.addEventListener("click", this.toggleOverflow.bind(this));

    // Re-check on window resize
    window.addEventListener("resize", this.checkOverflow.bind(this));
  },

  destroyed() {
    // Clean up event listener
    window.removeEventListener("resize", this.checkOverflow.bind(this));
  },

  checkOverflow() {
    // Get the content element (the container itself)
    const container = this.el;

    // Create a temporary clone to measure the full width
    const clone = container.cloneNode(true);
    clone.style.position = "absolute";
    clone.style.visibility = "hidden";
    clone.style.width = "auto";
    clone.style.whiteSpace = "nowrap";
    clone.classList.remove("truncate");
    document.body.appendChild(clone);

    // Compare widths to determine if content overflows
    const overflows = clone.offsetWidth > container.offsetWidth;

    // Remove the clone
    document.body.removeChild(clone);

    // Find the toggle icon
    const toggleIcon = container.querySelector(".toggle-icon");

    // Show or hide the toggle icon based on overflow
    if (toggleIcon) {
      if (overflows) {
        toggleIcon.classList.remove("hidden");
        container.classList.add("cursor-pointer");
      } else {
        toggleIcon.classList.add("hidden");
        container.classList.remove("cursor-pointer");
      }
    }
  },

  toggleOverflow() {
    this.el.classList.toggle("truncate");

    // Dispatch a custom event that the CalculateTranscriptTop hook will listen for
    window.dispatchEvent(new CustomEvent("js:calculate-transcript-top"));

    this.el.querySelector(".toggle-icon").classList.toggle("rotate-180");
  },
};
